/*
  TQP premium layer - reveal, ticker, rails and the mobile footer accordion.
  Oct 2026 speed pass: the old reveal measured every pending element with
  getBoundingClientRect on every scroll frame; reveal is now handled by the
  inline TQMotion engine (theme.liquid) with an IntersectionObserver fallback.
*/
(function () {
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  function reveal(root) {
    if (window.TQMotion) { window.TQMotion.scan(root || document); return; }
    var els = [].slice.call((root || document).querySelectorAll('.tqp-reveal:not(.is-in)'));
    if (!els.length) return;
    if (RM || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });
    }
    els.forEach(function (e) { io.observe(e); });
  }
  function ticker(root) {
    [].forEach.call((root || document).querySelectorAll('.tqp-ticker__track:not([data-cloned])'), function (t) {
      t.setAttribute('data-cloned', '1');
      t.innerHTML += t.innerHTML;
    });
  }
  function rails(root) {
    [].forEach.call((root || document).querySelectorAll('.tqp-rail:not([data-bound])'), function (r) {
      r.setAttribute('data-bound', '1');
      var track = r.querySelector('.tqp-rail__track');
      var nav = r.closest('section') ? r.closest('section').querySelectorAll('.tqp-rail__btn') : [];
      if (!track || !nav.length) return;
      [].forEach.call(nav, function (b) {
        b.addEventListener('click', function () {
          var dir = b.getAttribute('data-dir') === 'prev' ? -1 : 1;
          var rtl = document.documentElement.getAttribute('dir') === 'rtl' ? -1 : 1;
          track.scrollBy({ left: dir * rtl * Math.round(track.clientWidth * 0.85), behavior: 'smooth' });
        });
      });
    });
  }
  function init(root) { ticker(root); rails(root); reveal(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();

/* mobile footer: column titles become accordions below 750px */
(function () {
  var MQ = '(max-width:749px)', built = false;
  function build() {
    if (built) return;
    var grid = document.querySelector('.ftr__grid');
    if (!grid) return;
    var cols = grid.children, made = 0;
    for (var i = 0; i < cols.length; i++) {
      var col = cols[i];
      var title = col.querySelector(':scope > .ftr__title');
      if (!title) continue;
      var panel = document.createElement('div');
      panel.className = 'ftr__panel';
      var n = title.nextElementSibling;
      if (!n || n.tagName !== 'UL') continue;
      while (n) { var nx = n.nextElementSibling; panel.appendChild(n); n = nx; }
      if (!panel.children.length) continue;
      col.appendChild(panel);
      col.classList.add('ftr__acc');
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', 'false');
      (function (c, t) {
        function toggle() {
          var open = c.classList.toggle('is-open');
          t.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        t.addEventListener('click', function (e) { if (window.matchMedia(MQ).matches) { e.preventDefault(); toggle(); } });
        t.addEventListener('keydown', function (e) {
          if (window.matchMedia(MQ).matches && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); toggle(); }
        });
      })(col, title);
      made++;
    }
    built = made > 0;
  }
  function init() { if (window.matchMedia(MQ).matches) build(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', init, { passive: true });
})();
